import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Locked24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.9375 11.0625C6.73039 11.0625 6.5625 11.2304 6.5625 11.4375V19.3125C6.5625 19.5196 6.73039 19.6875 6.9375 19.6875H17.0625C17.2696 19.6875 17.4375 19.5196 17.4375 19.3125V11.4375C17.4375 11.2304 17.2696 11.0625 17.0625 11.0625H6.9375ZM5.0625 11.4375C5.0625 10.402 5.90197 9.5625 6.9375 9.5625H17.0625C18.098 9.5625 18.9375 10.402 18.9375 11.4375V19.3125C18.9375 20.348 18.098 21.1875 17.0625 21.1875H6.9375C5.90197 21.1875 5.0625 20.348 5.0625 19.3125V11.4375Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.3125C11.1546 4.3125 10.3439 4.64832 9.7461 5.2461C9.14832 5.84387 8.8125 6.65462 8.8125 7.5V10.3125C8.8125 10.7267 8.47671 11.0625 8.0625 11.0625C7.64829 11.0625 7.3125 10.7267 7.3125 10.3125V7.5C7.3125 6.2568 7.80636 5.06451 8.68544 4.18544C9.56451 3.30636 10.7568 2.8125 12 2.8125C13.2432 2.8125 14.4355 3.30636 15.3146 4.18544C16.1936 5.06451 16.6875 6.2568 16.6875 7.5V10.3125C16.6875 10.7267 16.3517 11.0625 15.9375 11.0625C15.5233 11.0625 15.1875 10.7267 15.1875 10.3125V7.5C15.1875 6.65462 14.8517 5.84387 14.2539 5.2461C13.6561 4.64832 12.8454 4.3125 12 4.3125Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 13.5C12.4142 13.5 12.75 13.8358 12.75 14.25V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V14.25C11.25 13.8358 11.5858 13.5 12 13.5Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
